var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import { RECENT_SEARCH_LC } from './constants';
const resources = {};
let cancel;
export const fetchAutocomplete = (queryUrl, query, setError) => __awaiter(void 0, void 0, void 0, function* () {
    if (cancel) {
        cancel.cancel();
    }
    cancel = axios.CancelToken.source();
    try {
        if (resources[query]) {
            return resources[query];
        }
        const res = yield axios.get(`${queryUrl}${query}`, {
            cancelToken: cancel.token,
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
        });
        const result = res.data.data.slice(0, 10);
        return result;
    }
    catch (error) {
        if (axios.isCancel(error)) {
        }
        else {
            setError('Something went wrong. Please try again.');
        }
    }
    return false;
});
export const clearRecentSearches = () => {
    try {
        localStorage.removeItem(RECENT_SEARCH_LC);
    }
    catch (err) {
    }
};
export const getRecentSearches = () => {
    const recentValue = localStorage.getItem(RECENT_SEARCH_LC);
    const prepareRecentObj = recentValue ? JSON.parse(recentValue) : [];
    return prepareRecentObj.map((item) => typeof item === 'object' ? item : { phrase: item, category: '' });
};
export const prepareUpdatedRecentSearches = ({ phrase, categories }, currentRecentSearches) => {
    if (currentRecentSearches) {
        const filteredResults = currentRecentSearches.filter((element) => {
            if (typeof element === 'object') {
                return JSON.stringify(element) !== JSON.stringify({ phrase, categories: categories || [] });
            }
            return element !== phrase;
        });
        filteredResults.unshift({ phrase, categories: categories || [] });
        return filteredResults;
    }
    return [];
};
export const saveRecentSearchesLocally = (recentSearches) => {
    try {
        localStorage.setItem(RECENT_SEARCH_LC, JSON.stringify(recentSearches.slice(0, 4)));
    }
    catch (err) {
    }
};
//# sourceMappingURL=utils.js.map